export const isNotEmptyObject = (val: unknown): boolean => {
  if (typeof val === 'object' && val !== null) {
    return !!Object.keys(val).length;
  }
  return false;
};
